export const DRAFT_WORKSPACE_WORKFLOW_SKILL_NAME =
  "draft_workspace_workflow_skill";

export const DRAFT_WORKSPACE_WORKFLOW_SKILL_DESC = `Creates a DRAFT workspace skill from a structured workflow description.

Inputs:
- organizationId (optional): The server binds this to the active authorized chat workspace.
- title (required): Skill title.
- useWhen (required): Situations where this workflow should be used.
- avoidWhen (optional): Situations where this workflow should not be used.
- steps (required): Ordered workflow steps.
- allowedToolNames (optional): Tool names the workflow may rely on.
- outputContract (required): How the final answer should be shaped.
- failureHandling (required): What to do when the workflow cannot continue.

Use this when a user wants to save a repeatable workflow for admin review. This creates a DRAFT only.`;
